
import { MessageCircle, Phone } from "lucide-react";
import "./FloatingContactButtons.css";

const FloatingContactButtons = () => {
  const phoneNumber = "+919971815737";

  const whatsappMessage = encodeURIComponent(
    "Hello SHREE BRAINS, I would like to know more about your services."
  );

  return (
    <div className="floating-contact-buttons">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber.replace("+", "")}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Chat with us on WhatsApp"
        title="WhatsApp"
      >
        <MessageCircle size={27} strokeWidth={2.2} />
      </a>

      {/* Call Button */}
      <a
        href={`tel:${phoneNumber}`}
        className="floating-btn call-btn"
        aria-label="Call SHREE BRAINS"
        title="Call us"
      >
        <Phone size={25} strokeWidth={2.2} />
      </a>
    </div>
  );
};

export default FloatingContactButtons;